import toShort from "./dateParser";
import {pcLogo} from "../components/icons/pc_logo";
import {tuidaLogoBlack} from "../components/icons/tuida-logo";

const svgToDataUri = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

const handlePrintLabel = (order) => {
  // Create a hidden iframe for printing
  const printFrame = document.createElement("iframe");
  printFrame.style.position = "absolute";
  printFrame.style.left = "-9999px";
  printFrame.style.top = "0";
  document.body.appendChild(printFrame);

  const pcLogoSrc = svgToDataUri(pcLogo);
  const tuidaLogoSrc = svgToDataUri(tuidaLogoBlack);

  
  const labelContent = `
<html lang="en">
<head>
  <title>Label - ${order.internalNo}</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
  <style>
    @page {
      size: 100mm 62mm;
      margin: 0;
    }

    @media print {
      html, body {
        width: 100mm !important;
        height: 62mm !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }

      .label {
        margin: 1mm;
        width: 98mm;
        height: 60mm;
        box-sizing: border-box;
        padding: 3mm;
        font-family: "Roboto", Arial, sans-serif;
        font-size: 11pt;
        border: 1px solid #000;
        overflow: hidden;
        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;
        }
      
      .header {
        margin-bottom: 2mm;
        border-bottom: 1px solid #000;
        padding-bottom: 1mm;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .logo-img { display:block; height:6mm; width:auto; }

      .order {
        font-weight: bold;
        font-size: 14pt;
          text-align: center;
      
      }
      .content {
        display: flex;
        justify-content: space-between;
        }
          
      .qr {
        margin-left: auto;
        margin-top: 24px;
        }

      .field {
        font-size: 10pt;
        margin: 1mm 0;
        }
      
      .field.small {
        font-size: 8pt;
        }

      .field.border {
        border: 1px dashed #000;
        padding: 1mm;
        margin-top: 1mm;
        margin-bottom: 1mm;
        }

      .field-label {
        font-weight: bold;
        }

      .barcode-area {
        text-align: left;
        font-size: 8pt;
        }
        
      .footer {
        font-size: 8pt;
        margin-top: 2mm;
        padding-top: 1mm;
        border-top: 1px dashed #aaa;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: auto;
        position: fixed;
        bottom: 4mm;
        width: 92mm;
        }

      .printed-info {
        font-size: 8pt;
        text-align: right;
        margin-top: 1mm;}

      /* Prevent accidental extra elements */
      body > *:not(.label) {
        display: none !important;
      }
    }

    /* Non-print styles for preview */
    body {
      width: 100mm;
      height: 62mm;
      margin: 0;
      padding: 3mm;
      font-family: Arial, sans-serif;
      font-size: 11pt;
      box-sizing: border-box;
    }
  </style>
</head>
<body>
  <div class="label">
    <div>
      <div class="header">
        <img class="logo-img" src="${pcLogoSrc}" alt="Plane Care logo"/>
        <div class="order">${order.internalNo}</div>
        <img class="logo-img" src="${tuidaLogoSrc}" alt="TuidaLab logo"/>
      </div>
      <div class="content">
        <div>
          <div class="field"><span class="field-label">Component:</span> ${order.componentName || "N/A"}</div>
          <div class="field"><span class="field-label">Part:</span> ${order.partNumber}</div>
          <div class="field"><span class="field-label">Serial:</span> ${order.serialNumber}</div>
          <div class="field"><span class="field-label">Date In:</span> ${toShort(order.dateIn)}</div>
          <div class="field"><span class="field-label">Work started:</span> ${toShort(order.workStarted)}</div>
          <div class="field"><span class="field-label">Work completed:</span> ${toShort(order.workCompleted)}</div>
          <div class="field"><span class="field-label">Status:</span> ${order.status}</div>
          <div class="field border"><span class="field-label">Customer:</span> <strong>${order.customerName}</strong></div>
          <div class="field small"><span class="field-label">Reason:</span> ${order.reason}</div>
          <div class="field small"><span class="field-label">Remarks:</span> ${order.remarks}</div>
        </div>
        <div class="qr">
          <img src="https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
            "pcacad.ddns.net:2025/"
          )}&size=75x75" alt="QR Code" style="display:block; margin: 0 auto;"/>
        </div>
      </div>
      <!--
      <div class="footer">
        <div class="barcode-area">Plane Care Ltd.</div>
        <div class="printed-info">
          ${toShort(new Date())}
        </div>
      </div>
      -->
    </div>
  </div>

  <script>
    window.onload = function() {
      // Enforce exact label size and single page
      document.documentElement.style.width = '100mm';
      document.documentElement.style.height = '62mm';
      document.body.style.width = '100mm';
      document.body.style.height = '62mm';
      document.body.style.overflow = 'hidden';
      
      window.print();
      setTimeout(() => window.close(), 100);
    };
  </script>
</body>
</html>`;

  // Write to iframe and print
  printFrame.contentDocument.write(labelContent);
  printFrame.contentDocument.close();

  
};

export default handlePrintLabel;
